<div class="sticky-top d-none d-xxxl-block">
  <ng-container [ngTemplateOutlet]="teaserContent"></ng-container>
</div>

<ng-template
  #content
  let-offcanvas
>
  <div class="offcanvas-header m-0 pb-0">
    <base-button
      color="transparent"
      icon="fa-solid fa-times"
      class="ms-auto"
      [iconSize]="buttonSize.md"
      (btnClick)="offcanvas.dismiss()"
    ></base-button>
  </div>
  <div class="offcanvas-body">
    <ng-container [ngTemplateOutlet]="teaserContent"></ng-container>
  </div>
</ng-template>

<ng-template #teaserContent>
  <form
    class="h-100"
    [formGroup]="editInquiryForm"
    [ngClass]="{ 'was-validated': submitted }"
  >
    <div class="shift-plan-sidebar h-100">
      <h5 *ngIf="isEmployeeShiftPlan">
        {{ 'externalEmployees.inquireSpecificEmployee' | translate: { employeeFullName: inquiredEmployeeName } }}
      </h5>
      <base-dropdown
        [items]="departments"
        formControlName="customerDepartment"
        [searchable]="false"
        bindOptionLabel="primaryData.name"
        label="department.singular"
        placeholder="placeholders.selectDepartment"
      >
      </base-dropdown>
      <hr />
      <div class="mt-3">
        <label>{{ 'contactPerson' | translate }}</label>
        <div
          *ngIf="editInquiryForm.get('responsible')?.value"
          class="contact-person"
        >
          <base-avatar
            [image]="person?.avatar || ''"
            [size]="baseAvatarSize.small"
          ></base-avatar>
          <span class="fw-bold">{{ person?.firstName }} {{ person?.lastName }}</span>
          <i
            class="fa-solid fa-close"
            (click)="removeContactPerson()"
          ></i>
        </div>
        <div
          *ngIf="!editInquiryForm.get('responsible')?.value"
          class="d-flex flex-column gap-2"
        >
          <base-dropdown
            [items]="users"
            formControlName="responsible"
            [searchable]="false"
            bindOptionLabel="fullName"
            bindOptionValue="party"
            [requiredAnother]="['fillInDepartmentFirst', !editInquiryForm.get('customerDepartment')?.value]"
            placeholder="placeholders.selectContactPerson"
            baseFieldValidationArgs="selectResponsible"
          >
          </base-dropdown>
        </div>
      </div>

      <hr />

      <div class="mt-3">
        <base-dropdown
          [items]="qualifications"
          [virtualScroll]="true"
          formControlName="mainQualification"
          [requiredAnother]="['fillInDepartmentFirst', !editInquiryForm.get('customerDepartment')?.value]"
          placeholder="placeholders.selectPrimaryJob"
          label="primaryQualification"
          baseFieldValidationArgs="selectResponsible"
          [markFavourites]="true"
        >
        </base-dropdown>
      </div>

      <hr />

      <div class="mt-3">
        <base-dropdown
          [items]="filteredQualifications"
          [virtualScroll]="true"
          [multiple]="true"
          outputModel="id"
          formControlName="qualifications"
          [requiredAnother]="['fillInDepartmentFirst', !editInquiryForm.get('customerDepartment')?.value]"
          placeholder="placeholders.selectSecondaryJob"
          label="secondaryQualification"
          baseFieldValidationArgs="selectResponsible"
          [markFavourites]="true"
        >
        </base-dropdown>
      </div>

      <hr />

      <div class="mt-3">
        <base-textarea
          label="jobDescription"
          formControlName="jobDescription"
          [autoGrowEnabled]="true"
          [isInvalid]="!!editInquiryForm.get('jobDescription')?.errors"
          [errorMessage]="
            editInquiryForm.get('jobDescription')?.errors | baseFieldValidation: { required: 'selectJobDescription' }
          "
        ></base-textarea>
      </div>

      <hr />

      <div class="mt-3 d-flex flex-column">
        <label>{{ 'conditions' | translate }}</label>
        <div class="d-flex align-items-center gap-2">
          <base-input
            type="number"
            placeholder="40"
            formControlName="weeklyWorkingHours"
          ></base-input>
          <div>{{ 'work.hoursPerWeek' | translate }}</div>
        </div>
      </div>

      <hr />

      <div class="d-flex flex-column mt-3">
        <label class="mt-2 fw-medium">{{ 'costUnit' | translate }}</label>
        <base-input
          formControlName="costUnit"
          class="col"
          [isInvalid]="!!editInquiryForm.get('costUnit')?.errors"
          [errorMessage]="
            editInquiryForm.get('costUnit')?.errors?.maxLength
              ? 'validation.maxLength'
              : (editInquiryForm.get('costUnit')?.errors | baseFieldValidation)
          "
        ></base-input>
      </div>

      <hr />

      <div class="d-flex flex-column mt-3">
        <div class="d-flex flex-column">
          <label class="d-block mt-2 fw-medium mb-0">{{ 'workEquipment' | translate }}</label>
          <span class="fs-8">{{ 'providedByUs' | translate }}</span>
        </div>
        <base-input
          formControlName="workEquipmentCustomer"
          class="col"
          [isInvalid]="!!editInquiryForm.get('workEquipmentCustomer')?.errors"
          [errorMessage]="
            editInquiryForm.get('workEquipmentCustomer')?.errors?.maxLength
              ? 'validation.maxLength'
              : (editInquiryForm.get('workEquipmentCustomer')?.errors | baseFieldValidation)
          "
        ></base-input>
      </div>

      <hr />

      <div class="d-flex flex-column mt-3">
        <div class="d-flex flex-column">
          <label class="d-block mt-2 fw-medium mb-0">{{ 'workEquipment' | translate }}</label>
          <span class="fs-8">{{ 'providedByServiceProvider' | translate }}</span>
        </div>
        <base-input
          formControlName="workEquipmentPsp"
          class="col"
          [isInvalid]="!!editInquiryForm.get('workEquipmentPsp')?.errors"
          [errorMessage]="
            editInquiryForm.get('workEquipmentPsp')?.errors?.maxLength
              ? 'validation.maxLength'
              : (editInquiryForm.get('workEquipmentPsp')?.errors | baseFieldValidation)
          "
        ></base-input>
      </div>

      <hr />

      <div class="mt-3">
        <base-dropdown
          [items]="filteredRequirements"
          formControlName="requirements"
          label="work.conditions.alt"
          placeholder="placeholders.selectRequirements"
          [multiple]="true"
          placement="top"
          outputModel="id"
        ></base-dropdown>
      </div>

      <hr />

      <div class="d-flex flex-column mt-3">
        <div class="d-flex flex-column">
          <label class="fw-medium">{{ 'inquiry.remark' | translate }}</label>
        </div>
        <base-textarea
          placeholder="placeholders.remark"
          class="col"
          formControlName="remark"
        ></base-textarea>
      </div>

      <hr />

      <div class="d-flex flex-column mt-3">
        <div class="d-flex flex-column">
          <label class="fw-medium">{{ 'document.singular' | translate }}</label>
        </div>
        <div class="w-100">
          <base-customer-inquiry-document [inquiryId]="inquiryId"></base-customer-inquiry-document>
        </div>
      </div>
    </div>
  </form>
</ng-template>
